module.exports = __webpack_public_path__ + "static/media/servicios-login.48f33ccb.png";